import type { Metadata } from "next";
import { Bebas_Neue, Geist, Geist_Mono, Raleway, Roboto_Mono } from "next/font/google";
import localFont from "next/font/local";

export const surgena = localFont({
  src: "../../public/fonts/surgenapersonaluseonlysembd-q2qwd.ttf",
  weight: "400",
  style: "normal",
  variable: "--font-surgena"
});

export const geistSans = Geist({
  variable: "--font-geist-sans",
  subsets: ["latin"]
});
export const bebasNue = Bebas_Neue({
  weight: "400",
  style: ["normal"],
  variable: "--font-bebas-neue",
  subsets: ["latin"]
});
export const robotoMono = Roboto_Mono({
  variable: "--font-roboto-mono",
  adjustFontFallback: true,
  display: "swap",
  style: "normal",
  subsets: ["latin"]
});
export const raleway = Raleway({
  variable: "--font-raleway",
  adjustFontFallback: true,
  style: "normal",
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  subsets: ["latin"]
});
export const geistMono = Geist_Mono({
  variable: "--font-geist-mono",
  subsets: ["latin"]
});
export const moonWalk = localFont({
  src: "../../public/fonts/Moon Walk.ttf",
  variable: "--font-moon-walk"
});

export const metadata: Metadata = {
  title: "Create Next App",
  description: "Generated by create next app",
  manifest: "/manifest.json",
  icons: {
    icon: "/public/icons/HUCO-192x192.png"
  }
};
